import { writable } from 'svelte/store';

export const user = writable(null);
export const templates = writable([]);
export const channels = writable([]);
export const events = writable([]);
